import Logo from "./icon.png";
import bgImg1 from "./bg-shape.png";
import bgImg2 from "./shape-2.png";
import ezLogo from "./ezLogo.jpg";
import wallpaper from "./5.jpg";
import login from "./login.jpg";
export const images = {
  Logo,
  bgImg1,
  bgImg2,
  ezLogo,
  wallpaper,
  login,
};
